import { Directive, input } from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';

import type { InputSignal } from '@angular/core';

@Directive({
  selector: '[tdWbScrollable]',
  host: {
    '[attr.tabindex]': 'tabbable() ? "0" : "-1"',
    '[style.outline]': '"none"'
  }
})
export class ScrollableDirective extends CdkScrollable {

  tabbable: InputSignal<boolean> = input<boolean>(true, { alias: 'tabbable' });

  scrollSize: number = 333;

  getElementRect(): DOMRect {
    return this.getElementRef().nativeElement.getBoundingClientRect();
  }

  refreshScrollSize(): void {
    const elementRect = this.getElementRect();
    if (elementRect !== undefined) {
      this.scrollSize = elementRect.width;
    }
  }
}
